export default function gestionWarningEtatObtenu(messagesAvertissement) {
  const messages = [];
  messagesAvertissement.forEach(message => {
    if (message.indexOf('INSUFFICIENT_STOCK_YEARWEEK') !== -1) {
      messages.push('optionBlocage.messageErreurQuantite');
    }
    if (message.indexOf('IMPOSSIBLE_TO_BLOCK_OPTION') !== -1) {
      messages.push('optionBlocage.messageErreurEtat');
    }
    if (message.indexOf('OPTION_ON_BLOCKED_LINE_FORBIDDEN') !== -1) {
      messages.push('optionBlocage.messageErreurEtat');
    }
    if (message.indexOf('QTE_SOUHAITEE_REQUIRED') !== -1) {
      messages.push('optionBlocage.messageErreurQuantiteNull');
    }
  });
  return messages;
}
